import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { ApplicationContext } from "../../context/application-context.service";
import { OfflineError } from "../errors/network-errors";

export interface AppOfflineInterceptorOptions {
  ignoredEndpoints?: string[];
}

export function appOfflineInterceptor(options: AppOfflineInterceptorOptions = {}): HttpInterceptorFn {
  const ignoredEndpoints = options.ignoredEndpoints ?? [];

  return (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const applicationContext = inject(ApplicationContext);
    const requestUrl = req.url.startsWith("http") ? new URL(req.url).pathname : req.url;
    const isIgnored = ignoredEndpoints.some(endpoint => requestUrl.includes(endpoint));

    if (isIgnored) {
      return next(req);
    }

    if (applicationContext.offlineSyncInProgress()) {
      return next(req);
    }

    if (applicationContext.appOffline()) {
      return throwError(() => new OfflineError("App is offline"));
    }

    return next(req);
  };
}
